/* @flow weak */
import enumerate from 'lib/enumerate';

export const ActionTypes = enumerate([
  'GROUP_AVATARS_LOADED',
]);



// WEBPACK FOOTER //
// ./src/constants/AvatarConstants.js